var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0994 4.35395C3.2764 1.75056 5.902 0 8.84449 0C12.2849 0 15.318 2.37896 16.0423 5.70053C16.1328 6.01473 15.9065 6.32893 15.6348 6.37382C15.318 6.46359 15.0011 6.28405 14.9105 5.96985C14.2768 3.14202 11.7417 1.12215 8.84449 1.12215C6.44523 1.12215 4.31759 2.51362 3.2764 4.53349L4.5892 4.75792C4.72501 4.75792 4.77028 4.89258 4.67974 4.98235L2.46156 7.45109C2.41629 7.54086 2.28048 7.49597 2.23521 7.4062L0.605526 4.39883C0.560257 4.26418 0.650795 4.12952 0.786602 4.1744L2.0994 4.35395Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4539 10.6461C14.2806 13.2495 11.6632 15.0001 8.72985 15.0001C5.25499 15.0001 2.27653 12.6211 1.55448 9.29955C1.46423 8.98535 1.64474 8.67115 1.96064 8.62626C2.27653 8.53649 2.59243 8.71603 2.63756 9.03023C3.26935 11.8581 5.79653 13.8779 8.72985 13.8779C11.1216 13.8779 13.2427 12.4865 14.2806 10.4217L13.017 10.2422C12.8816 10.2422 12.8365 10.1075 12.9268 9.97284L15.138 7.54899C15.1832 7.45922 15.3186 7.50411 15.3637 7.59388L16.9883 10.6012C17.0334 10.7359 16.9432 10.8706 16.8078 10.8257L15.4539 10.6461Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/sync-icon.322534402fae28feb70d58b9cf18e1d9.svg";
export { ForwardRef as ReactComponent };